export default {
  en: {
    title: 'Remote support over VPN',
    connectButton: 'Connect',
    disconnectButton: 'Disconnect',
    vpnStatus: 'VPN status - ',
    logs: 'Logs',
    unknown: 'unknown',
    connected: 'connected',
    disconnected: 'disconnected',
  },
};
